<template>
    <div class="modal fade" id="static-massive-action" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title w-100">
                        <h2 class="mt-0 title--1">
                            Are you sure you want to {{(action_restore)?'restore':'delete'}}
                        </h2>
                        <h3 class="subtitle--1">
                            Confirmation
                        </h3>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text my-3"> 
                           All selected records will be {{(action_restore)?'restored':'deleted'}} and you will {{(action_restore)?'':'not'}} be able to see them
                        </p>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="Imagen de una equis">
                    </button>
                </div>
                <div class="modal__buttons mt-0 text-center text-md-right">
                    <button type="button" data-dismiss="modal" class="modal__buttons__item cancel">Cancel</button>
                    <button type="button" class="modal__buttons__item" @click="event_emition()">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name:   'DeletionMassiveModal',
    
    props:  [
        'action_restore',
    ],

    methods:{
        event_emition(){
            this.$emit('objectDeletion', true);
        }
    },

    mounted(){

    }
}
</script>